import { FunctionComponent } from "react";
import { graphql } from "@apollo/client/react/hoc";

import {
    CONCEPTS_QUERY,
    CREATE_CONCEPT_MUTATION,
    UPDATE_CONCEPT,
    DELETE_CONCEPT_MUTATION,
} from "../graphql";
import { captureException } from "@sentry/react";

// Query
export const withConcepts = (Component: FunctionComponent) =>
    graphql(CONCEPTS_QUERY, {
        options: ({ where, pagination }) => {
            return {
                variables: {
                    where,
                    ...pagination,
                },
            };
        },
        props: ({ data }) => {
            const {
                loading,
                error,
                concepts,
                fetchMore,
                subscribeToMore,
                updateQuery,
                refetch,
            } = data;
            const loadQuestionsData = (offset: number) => {
                return fetchMore({
                    variables: {
                        offset,
                    },
                    updateQuery: (previousResult, { fetchMoreResult }) => {
                        return {
                            concepts: [
                                ...previousResult.concepts,
                                ...fetchMoreResult.concepts,
                            ],
                        };
                    },
                });
            };
            if (error) throw new Error(error.message);
            return {
                loading,
                concepts,
                subscribeToMore,
                updateQuery,
                loadQuestionsData,
                refetchConcepts: refetch,
            };
        },
    })(Component);

// Mutation
export const withCreateConcept = (Component: FunctionComponent) =>
    graphql(CREATE_CONCEPT_MUTATION, {
        props: ({ mutate }) => ({
            createConcept: async (object: Object) => {
                console.log(
                    "🚀 ~ file: Operations.ts ~ line 60 ~ createConcept: ~ object",
                    object,
                );
                try {
                    const {
                        data: { insert_concept_one },
                    } = await mutate({
                        variables: { object },
                        optimisticResponse: {
                            __typename: "Mutation",
                            createConcept: {
                                object,
                                __typename: "INSERT_CONCEPT_ONE",
                            },
                        },
                    });
                    return insert_concept_one;
                } catch (e) {
                    captureException(e)
                    console.error(e);
                }
            },
        }),
    })(Component);

export const withUpdateConcept = (Component: FunctionComponent) =>
    graphql(UPDATE_CONCEPT, {
        props: ({ mutate }) => ({
            updateConcept: (object: Object) => {
                mutate({
                    variables: { ...object },
                    optimisticResponse: {
                        updateConcept: {
                            ...object,
                            __typename: "concept",
                        },
                    },
                });
            },
        }),
    })(Component);

export const withDeleteConcept = (Component: FunctionComponent) =>
    graphql(DELETE_CONCEPT_MUTATION, {
        props: ({ mutate }) => ({
            deleteConcept: (id: string) => {
                mutate({
                    variables: { id },
                    optimisticResponse: {
                        __typename: "Mutation",
                        deleteConcept: {
                            id,
                            __typename: "DELETE_CONCEPT_BY_PK",
                        },
                    },
                });
            },
        }),
    })(Component);
